<template>
  <div class='EnbCompNaves'>
    <div
    class="cont-comp"
    v-for="(c, key) in comps"
    :key="key"
    >
      <input type="checkbox" :checked="c.selected" @click="exec(c.name)">
      <component :is="c.name" pref/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Naves from '@/components/Naves'
export default {
  name: 'EnbCompNaves',
  components: { ...Naves },
  data () {
    return {
      comps: [
        {
          name: 'EnbNave01',
          selected: true
        },
        {
          name: 'EnbNave02',
          selected: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['UpdatePrefComp']),
    exec (value) {
      this.comps = this.comps.map(c => {
        if(c.name === value) {
          c.selected = true
        }
        else {
          c.selected = false
        }
        return c
      })
      this.UpdatePrefComp({ comp: 'componentNave', prop: 'name', value: value })
    }
  },
  created () {
    if(this.Prefes?.componentNave) {
      this.comps = this.comps.map(c => {
        c.selected = c.name === this.Prefes.componentNave.name
        return c
      })
    }
  }
}
</script>

<style scoped>
.cont-comp {
  display: flex;
  margin-top: 1%;
}
</style>
